export default "__VITE_ASSET__C9Y3HAsu__"